<template>
    <div
        v-if="showed && auctionBids.length > 0"
        class="auction-detail-bids-list"
    >
        <div class="auction-detail-bids-list__row auction-detail-bids-list__row-header">
            <div class="auction-detail-bids-list__cell">
                <span>Время ставки</span>
            </div>

            <div class="auction-detail-bids-list__cell">
                <span>Ставка</span>
            </div>

            <div class="auction-detail-bids-list__cell">
                <span>ФИО</span>
            </div>

            <div class="auction-detail-bids-list__cell">
                <span>Дилер</span>
            </div>

            <div class="auction-detail-bids-list__cell auction-detail-bids-list__cell-icon">
                <span></span>
            </div>
        </div>

        <div
            v-for="bid in auctionBids"
            :key="'auction-bid-' + bid.id"
            class="auction-detail-bids-list__row"
        >
            <div class="auction-detail-bids-list__cell">
                <span>{{ formatFromUTC(bid.created_at) }}</span>
            </div>

            <div class="auction-detail-bids-list__cell">
                <span>
                    {{ numberFormat(bid.value) }} ₽
                </span>
            </div>

            <div class="auction-detail-bids-list__cell">
                <span>{{ bid.user_full_name }}</span>
            </div>

            <div class="auction-detail-bids-list__cell">
                <span>{{ bid.dealer_name }}</span>
            </div>

            <div class="auction-detail-bids-list__cell auction-detail-bids-list__cell-icon">
                <img
                    v-if="false"
                    v-svg-inline
                    src="@/assets/icons/ui/menu.svg"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { onMounted, PropType, ref, watch } from 'vue';

    import { Auction, AuctionBid } from '@/types/auction.type.ts';

    import useAuctionRepository from '@/repositories/auction/useAuctionRepository.ts';
    import usePermission from '@/repositories/auth/usePermission.ts';

    import { formatFromUTC } from '@/utils/DateTimeFormatter.ts';
    import { numberFormat } from '@/utils/NumberFormatter.ts';

    const { auction } = defineProps({
        auction: {
            type: Object as PropType<Auction>,
            required: true,
        },
        showed: {
            type: Boolean,
            default: false,
        },
    });

    const { canViewAuctionBids } = usePermission();
    const { getAuctionBids } = useAuctionRepository();

    const auctionBids = ref<AuctionBid[]>([]);

    watch(
        () => auction.broadcastInfo?.bids_count,
        () => fetchBids(),
    );

    function fetchBids(): void {
        if (!canViewAuctionBids()) {
            auctionBids.value = [];

            return;
        }

        getAuctionBids(auction.id).then((fetchedAuctionBids: AuctionBid[]) => {
            auctionBids.value = fetchedAuctionBids.sort((a: AuctionBid, b: AuctionBid) => {
                return b.id - a.id;
            });
        });
    }

    onMounted(() => {
        fetchBids();
    });
</script>

<style lang="scss" scoped>
    @use "ViewAuctionBidsList.scss";
</style>
